// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime elements
import { Table as TableElement, TableHead, TableFooter } from '../../_primes'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface TableFCProps extends WithStyles<typeof styles> {
    tableHeadComponent: JSX.Element
    tableBodyComponent: JSX.Element
    tableFooterComponent: JSX.Element
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const Table = (props: TableFCProps) => {
    const { classes } = props
    return (
        <div className={classes.TablePaper}>
            <div className={classes.TableWrapper}>
                <TableElement className={classes.Table}>
                    <TableHead>{props.tableHeadComponent}</TableHead>
                    {props.tableBodyComponent}
                    <TableFooter>{props.tableFooterComponent}</TableFooter>
                </TableElement>
            </div>
        </div>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        TablePaper: {
            width: '100%',
            marginTop: theme.spacing(),
        },
        Table: {
            minWidth: 500,
            tableLayout: 'fixed',
        },
        TableWrapper: {
            overflowX: 'auto',
        },
    })

export default withStyles(styles, { withTheme: true })(Table)
